import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import api from "../services/api";
import moment from "moment";
import "moment/locale/pt-br";

// Feather
import { Search, Filter, Download, AlertTriangle, ArrowLeft, Share2 } from "react-feather";

// Components
import Any from "../svgs/Any";
import Box from "../components/Box";
import Input from "../components/Input";
import Popup from "../components/Popup";
import Button from "../components/Button";
import UserCol from "../components/UserCol";
import Textarea from "../components/Textarea";
import NewInput from "../components/NewInput";
import PopupBody from "../components/PopupBody";
import PopupTags from "../components/PopupTags";
import PopupFixed from "../components/PopupFixed";
import PopupFooter from "../components/PopupFooter";
import PhoneNumber from "../components/PhoneNumber";
import DocDropzone from "../components/DocDropzone";
import PopupChatTags from "../components/PopupChatTags";
import CustomerTable from "../components/CustomerTable";
import BoxCustomerMenu from "../components/BoxCustomerMenu";
import PopupSocialMedia from "../components/PopupSocialMedia";
import PopupTransferDir from "../components/PopupTransferDir";
import PopupLastAccesses from "../components/PopupLastAccesses";
import ProspectPagination from "../components/Prospect/ProspectPagination";
import PopupSelectSocialMedia from "../components/PopupSelectSocialMedia";
import SocialMediaUser from "../components/SocialMediaUser";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";

import { Spinner } from "../components";
import { Link } from "react-router-dom";
import { useAuth } from "../providers/auth";
import openToast from "../utils/sweetAlert";
import LoadingCenter from "../components/LoadingCenter";
import ChartHours from "../components/ChartHours";
import { useHttp } from "../hooks/useHttp";
import useMediaType from "../hooks/useMediaType";

const schema = yup.object({
  command: yup.string().required("O campo comando precisa ser preenchido!").matches(/^\S+$/, "O comando não pode conter espaços em branco."),
  body: yup.string().required("O campo texto precisa ser preenchido!")
}).required();

const observationSchema = yup.object({
  observation: yup.string().required("Você precisa informar a observação acima!")
}).required();

function CustomersDir({ expiredMode = false }) {
  const { register: registerObservation, handleSubmit: handleSubmitObservation, reset, formState: { errors: errorsObservation } } = useForm({
    resolver: yupResolver(observationSchema)
  });

  const currentChat = useRef(null);
  const inputFilesRef = useRef(null);
  const currentCustomer = useRef(null);
  const numberPage = useRef(1); // usado pela paginação

  const { user } = useAuth();
  const request = useHttp();

  // dados/lista
  const [info, setInfo] = useState();
  const [infoLoading, setInfoLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(true);
  const [meta, setMeta] = useState({ current_page: 1, last_page: 1, per_page: 100, total: 0 });

  // filtros
  const [search, setSearch] = useState("");
  const [tags, setTags] = useState([]);           // array de IDs
  const [media, setMedia] = useState("");         // Whatsapp|Facebook|Instagram|Telegram
  const [access, setAccess] = useState("");       // today|7d|30d|never|<Nd>
  const [adminFilter, setAdminFilter] = useState(""); // id do admin

  // popups e afins
  const [buttonPopupLastAccesses, setButtonPopupLastAccesses] = useState(false);
  const [buttonPopupTags, setButtonPopupTags] = useState(false);
  const [buttonPopupTagsUser, setButtonPopupTagsUser] = useState(false);
  const [buttonPopupChatTags, setButtonPopupChatTags] = useState(false);
  const [buttonPopupSocialMedia, setButtonPopupSocialMedia] = useState(false);
  const [buttonPopupSocialMediaFilter, setButtonPopupSocialMediaFilter] = useState(false);
  const [mediaTrigger, setMediaTrigger] = useState(false);
  const [customerId, setCustomerId] = useState("");

  const [buttonPopupObs, setButtonPopupObs] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [obsLoading, setObsLoading] = useState(false);

  // ligar
  const [buttonPopupLigar, setButtonPopupLigar] = useState(false);
  const [listPhones, setListPhones] = useState([]);
  const [infoLoadingLigar, setInfoLoadingLigar] = useState(false);

  // juntar clientes
  const [buttonJoinClients, setButtonJoinClients] = useState(false);
  const [buttonJoinInfo, setButtonJoinInfo] = useState(false);
  const { register, handleSubmit } = useForm();
  const { register: registerMedia, handleSubmit: handleSubmitMedia, reset: resetMedia } = useForm();

  const { register: registerExport, handleSubmit: handleSubmitExport } = useForm();
  const { register: registerAdmin, handleSubmit: handleSubmitAdmin } = useForm();
  const { register: registerSearch, handleSubmit: handleSubmitSearch, formState: { errors: errorsSearch } } = useForm();

  const [users, setUsers] = useState([]);
  const [userId1, setUserId1] = useState("");
  const [userData1, setUserData1] = useState("");
  const [userId2, setUserId2] = useState("");
  const [userData2, setUserData2] = useState("");

  const [toggleAdvancedFilter, setToggleAdvancedFilter] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);

  const [downloadLoading, setDownloadLoading] = useState(false);
  const [popupExport, setPopupExport] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [adminsLoading, setAdminsLoading] = useState(false);

  const [filterAdminLoading, setFilterAdminLoading] = useState(false);
  const [popupAdminFilter, setPopupAdminFilter] = useState(false);

  // checkboxes
  const [actions, setActions] = useState(false);
  const [popupTransfer, setPopupTransfer] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const { getMediaType } = useMediaType();

  // helpers -------------------------------------------------------------

  const authHeaders = { headers: { Authorization: "Bearer " + user.token } };

  const buildMasterQueryString = () => {
    const params = new URLSearchParams();
    params.set("page", numberPage.current);
    params.set("per_page", meta.per_page || 100);

    const s = search.trim();
    if (s) params.set("search", s);
    if (tags?.length) params.set("tags_id", tags.join(","));
    if (media) params.set("social_media", media);
    if (access) params.set("access", access);
    if (adminFilter) params.set("admin", adminFilter);

    return params.toString();
  };

  const fetchCustomers = async () => {
    setCustomersLoading(true);
    try {
      const qs = buildMasterQueryString();
      const resp = await api.get(`/users/master?${qs}`, authHeaders);

      const list =
        resp?.data?.data?.map(c => ({ ...c, checked: false })) ??
        resp?.data?.dados?.map(c => ({ ...c, checked: false })) ??
        [];

      setCustomers(list);

      const m = resp.data?.meta || {
        current_page: numberPage.current,
        last_page: resp.data?.qtd || 1,
        per_page: 100,
        total: (resp.data?.qtd || 1) * 100
      };
      setMeta(m);
    } catch (e) {
      console.log(e);
    } finally {
      setCustomersLoading(false);
    }
  };

  const socialMediaMutation = useMutation({
    mutationKey: ["dir-social-medias"],
    mutationFn: id => request({ url: "/users/socialmedia/" + id, method: "GET" })
  });

  const takeOnCustomerMutation = useMutation({
    mutationKey: ["dir-take-on-customer"],
    mutationFn: selectedMedia => request({
      url: "/chats/novosl",
      method: "POST",
      data: { social_media: selectedMedia, user_id: customerId }
    }),
    onSuccess: response => {
      if (response.data.error) {
        openToast("error", "Ocorreu um erro", response.data.message);
        return;
      }

      setMediaTrigger(false);
      resetMedia();
      fetchCustomers();
      openToast("success", "Sucesso", response.data.message);
    },
    onError: error => {
      openToast("error", "Ocorreu um erro", error.response?.data?.message || "Não foi possível abrir o chat para você.");
    }
  });

  const handleSetMedia = data => takeOnCustomerMutation.mutate(data.social_media);

  const applyFilters = (resetPage = true) => {
    if (resetPage) numberPage.current = 1;
    fetchCustomers();
  };

  // efeitos iniciais
  useEffect(() => { fetchCustomers(); /* eslint-disable-line */ }, []);

  // filtros reativos
  useEffect(() => { if (tags) applyFilters(); /* eslint-disable-line */ }, [tags]);
  useEffect(() => { if (media !== "") applyFilters(); /* eslint-disable-line */ }, [media]);
  useEffect(() => { if (access !== "") applyFilters(); /* eslint-disable-line */ }, [access]);

  // ações específicas ----------------------------------------------------

  // set por último acesso (popup) - mantém endpoint existente (lista simples, sem paginação)
  async function setLastAccess(id) {
    try {
      const response = await api.get(`/users/last/access/${id}`, authHeaders);
      const list = response?.data?.dados?.map(c => ({ ...c, checked: false })) ?? [];
      setCustomers(list);
      setButtonPopupTags(false);
      setButtonPopupSocialMedia(false);
      setButtonPopupLastAccesses(false);
      // quando sair desse modo, clique em "Limpar filtros" para voltar ao /users/master
    } catch (err) {
      console.log(err);
    }
  }

  async function fetchCustomerById(id) {
    currentChat.current = { id };
    try {
      setInfoLoading(true);
      const response = await api.get(`/users/${id}`, authHeaders);
      setInfo(response.data);
      currentCustomer.current = response.data.juridic;
    } catch (error) {
      console.log(error);
    } finally {
      setInfoLoading(false);
    }
  }

  // busca (Enter ou clique no ícone)
  async function handleSearch(e = null) {
    if (e?.key && e.key !== "Enter") return;
    applyFilters(true);
  }

  // limpar filtros
  const clearFilters = async (e) => {
    e?.preventDefault?.();
    setSearch("");
    setTags([]);
    setMedia("");
    setAccess("");
    setAdminFilter("");
    numberPage.current = 1;
    fetchCustomers();
  };

  // avançado
  const advancedFilter = (e) => {
    e.preventDefault();
    setToggleAdvancedFilter(true);
  };

  const searchAdvancedFilter = async data => {
    setFilterLoading(true);
    const { cpf, rg, number, email } = data;
    try {
      const resp = await api.get(`/users/search/busca/avancada?cpf=${cpf || ""}&rg=${rg || ""}&number=${number || ""}&email=${email || ""}`, authHeaders);
      if (resp.data.error) {
        openToast("info", "Ocorreu um erro", resp.data.message);
      } else {
        const list = resp?.data?.map(c => ({ ...c, checked: false })) ?? [];
        setCustomers(list);
      }
    } catch (error) {
      if (error.response?.data?.error) {
        openToast("info", "Ocorreu um erro", error.response.data.message);
      }
    } finally {
      setFilterLoading(false);
      setToggleAdvancedFilter(false);
    }
  };

  // obs
  async function editObservation(data) {
    setObsLoading(true);
    try {
      const response = await api.post("/users/observation", { body: data.observation, user_id: info.id }, authHeaders);
      if (!response.data.error) {
        openToast("success", "Sucesso", response.data.message);
        setButtonPopupObs(false);
        reset();
        const user_do_chat = await api.get(`/users/${info.id}`, authHeaders);
        setInfo(user_do_chat.data);
      } else {
        openToast("error", "Erro", response.data.message);
      }
    } catch (error) {
      openToast("error", "Erro", "Ocorreu um erro na sua solicitação.");
      setButtonPopupObs(false);
    } finally {
      setObsLoading(false);
    }
  }

  // ligar
  async function pegaCliente(id) {
    try {
      setInfoLoadingLigar(true);
      const response = await api.get(`/users/list/phone/${id}`, authHeaders);
      setListPhones(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setInfoLoadingLigar(false);
    }
  }

  async function setNumber(data) {
    setError("");
    try {
      const response = await api.post("/calls/ligarsl", { user_id: info.id, phone: data.number }, authHeaders);
      if (response.data.error === true) {
        setError(response.data.message);
      }
    } catch (e) {}
  }

  // unir
  function onSubmitJoinUsers(data) {
    setUserId2(data.user);
    setButtonJoinClients(false);
    setButtonJoinInfo(true);
  }

  async function fetchUsers() {
    try {
      const response = await api.get("/users", { headers: { Authorization: "Bearer" + user.token } });
      setUsers(response?.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => { if (userId1) (async () => {
    try { const r = await api.get(`/users/${userId1}`, authHeaders); setUserData1(r.data);} catch(e){}
  })(); /* eslint-disable-line */ }, [userId1]);

  useEffect(() => { if (userId2) (async () => {
    try { const r = await api.get(`/users/${userId2}`, authHeaders); setUserData2(r.data);} catch(e){}
  })(); /* eslint-disable-line */ }, [userId2]);

  useEffect(() => { if (buttonJoinClients) fetchUsers(); /* eslint-disable-line */ }, [buttonJoinClients]);

  const onSubmitUnion = data => {
    console.log("-------------------");
    console.log("id:", data.id);
    console.log("name:", data.name);
    console.log("email:", data.email);
    console.log("nickname:", data.nickname);
    console.log("phone_number1:", data.phone_number1);
    console.log("cpf:", data.cpf);
    console.log("rg:", data.rg);
    console.log("state:", data.state);
    console.log("city:", data.city);
    console.log("deleted:", data.deleted);
    console.log("usadao_id:", data.usadao_id);
    console.log("-------------------");
  };

  const editInfoAdmin = async () => {
    const user_do_chat = await api.get(`/users/${info.id}`, authHeaders);
    setInfo(user_do_chat.data);
  };

  // export
  const fetchAdmins = async () => {
    try {
      setAdminsLoading(true);
      const response = await api.get("/admins/list", { headers: { Authorization: "Bearer" + user.token } });
      setAdmins(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setAdminsLoading(false);
    }
  };

  const openPopupExport = () => {
    fetchAdmins();
    setPopupExport(true);
  };

  const exportChat = async (data) => {
    setDownloadLoading(true);
    try {
      const response = await api.get(`/users/master/exportar?admin_id=${data.admin}`, authHeaders);
      if (!error) {
        openToast("success", "Exportação gerada com sucesso!", response.data?.message);
        window.location.assign(response.data.download_url);
      } else {
        openToast("error", "Erro!", response.data?.message);
      }
    } catch (error) {
      if (error.response) {
        openToast("error", "Erro!", error.response.data?.message);
      }
    } finally {
      setDownloadLoading(false);
    }
  };

  // filtro por admin -> agora só ajusta state e refaz /users/master com paginação
  const openModalFilterAdmin = (e) => {
    e.preventDefault();
    fetchAdmins();
    setPopupAdminFilter(true);
  };

  const filterForAdmin = async (data) => {
    setFilterAdminLoading(true);
    try {
      setAdminFilter(String(data.admin || "")); // seta filtro
      numberPage.current = 1;
      await fetchCustomers(); // usa /users/master com admin=...
    } catch (error) {
      if (error.response) {
        openToast("error", "Erro!", error.response.data?.message);
      }
    } finally {
      setFilterAdminLoading(false);
      setPopupAdminFilter(false);
    }
  };

  // checkboxes
  const onChangeCheck = (event, customer) => {
    const { checked } = event.target;
    setCustomers(customers.map(old => (customer.id === old.id ? { ...old, checked } : old)));
  };

  const onChangeAll = event => {
    const { checked } = event.target;
    setCustomers(customers.map(c => ({ ...c, checked })));
  };

  const onSubmit = (event) => {
    event.preventDefault();
    const selected = customers.filter(c => c.checked === true);
    setSelectedCustomers(selected);
    setPopupTransfer(true);
  };

  const transferCustomer = (customer) => {
    setSelectedCustomers([customer]);
    setPopupTransfer(true);
  };

  useEffect(() => {
    const selected = customers.filter(c => c.checked === true);
    setActions(selected.length > 0);
  }, [customers]);

  // ui -------------------------------------------------------------------

  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [facebookNumber, setFacebookNumber] = useState("");
  const [instagramNumber, setInstagramNumber] = useState("");

  return (
    <div className="customer-grid">

      {/* Unir clientes - escolha */}
      <form onSubmit={handleSubmit(onSubmitJoinUsers)} style={{ position: "relative" }}>
        <PopupFixed title="Lorem ipsum dolor" trigger={buttonJoinClients} setTrigger={setButtonJoinClients}>
          <PopupBody>
            <ul className="filter__list">
              {users && users.map(user => (
                <label key={user.id} className="list__label">
                  <li className="list__item">
                    <input className="radio__btn" type="radio" name="user" value={user.id} {...register("user")} />
                    <div className="list__item__image" style={{ backgroundImage: `url(${user.profile_pic})` }} />
                    <p className="list__item__name">{user.name}</p>
                  </li>
                </label>
              ))}
            </ul>
          </PopupBody>
          <PopupFooter right={true}>
            <button className="btn btn-primary" type="submit">Unir clientes</button>
          </PopupFooter>
        </PopupFixed>
      </form>

      <PopupTransferDir customers={selectedCustomers} trigger={popupTransfer} setTrigger={setPopupTransfer} onSuccess={fetchCustomers} />

      {/* Export */}
      <Popup title="Exportar clientes" trigger={popupExport} setTrigger={setPopupExport}>
        <div className="chat__filter u-mb-1">
          <form onSubmit={handleSubmitExport(exportChat)}>
            <ul className="filter__list">
              {admins && admins.map((admin, index) => (
                <label key={index} className="list__label">
                  <li className="list__item">
                    <input className="radio__btn" type="radio" name="admin" value={admin.id} {...registerExport("admin")} />
                    <div className="list__item__image" style={{ backgroundImage: `url(${admin.profile_picture})` }} />
                    <p className="list__item__name">{admin.name}</p>
                  </li>
                </label>
              ))}
            </ul>
            <div className="u-padding">
              <button className="btn btn-primary" type="submit" disabled={adminsLoading || downloadLoading}>
                {adminsLoading || downloadLoading ? <Spinner /> : "Exportar Clientes"}
              </button>
            </div>
          </form>
        </div>
      </Popup>

      {/* Filtro Admin */}
      <Popup title="Filtro por admin" trigger={popupAdminFilter} setTrigger={setPopupAdminFilter}>
        <div className="chat__filter u-mb-1">
          {adminsLoading && <LoadingCenter />}
          <form onSubmit={handleSubmitAdmin(filterForAdmin)}>
            <ul className="filter__list">
              {admins && admins.map((admin, index) => (
                <label key={index} className="list__label">
                  <li className="list__item">
                    <input className="radio__btn" type="radio" name="admin" value={admin.id} {...registerAdmin("admin")} />
                    <div className="list__item__image" style={{ backgroundImage: `url(${admin.profile_picture})` }} />
                    <p className="list__item__name">{admin.name}</p>
                  </li>
                </label>
              ))}
            </ul>
            <div className="u-padding" style={{ paddingBottom: "10px" }}>
              <button className="btn btn-primary" type="submit" disabled={adminsLoading || downloadLoading}>
                {filterAdminLoading ? <Spinner /> : "Filtrar clientes"}
              </button>
            </div>
          </form>
        </div>
      </Popup>

      <PopupChatTags title="Gerenciar tags" info={info} trigger={buttonPopupTagsUser}
        setTrigger={setButtonPopupTagsUser} editInfoAdmin={editInfoAdmin} chat={currentChat} />

      {/* Filtro avançado (busca direta, sem paginação) */}
      <Popup title="Filtro avançado" trigger={toggleAdvancedFilter} setTrigger={setToggleAdvancedFilter} >
        <div className="u-padding-20-all" style={{ paddingTop: "0px" }}>
          <form onSubmit={handleSubmitSearch(searchAdvancedFilter)}>
            <Input label="Cpf" name="cpf" type="text" placeholder="00000000000" error={errorsSearch?.cpf} register={registerSearch} />
            <Input label="Rg" name="rg" type="text" placeholder="00000000000" error={errorsSearch?.rg} register={registerSearch} />
            <Input label="Telefone" name="number" type="text" placeholder="00000000000" error={errorsSearch?.number} register={registerSearch} />
            <Input label="E-mail" name="email" type="text" placeholder="email@dominio.com" error={errorsSearch?.email} register={registerSearch} />
            <div className="mt-20"></div>
            <Button title="Pesquisar" type="submit" color="green" width="full" loading={filterLoading} onClick={() => { }} />
          </form>
        </div>
      </Popup>

      {/* Selecionar telefone */}
      <Popup title="Selecionar telefone" trigger={buttonPopupLigar} setTrigger={setButtonPopupLigar} >
        {infoLoadingLigar ? (
          <LoadingCenter />
        ) : (
          <form onSubmit={handleSubmit(setNumber)}>
            <div className="padding-inner" style={{ paddingTop: "0px" }}>
              {infoLoading ? (
                <LoadingCenter />
              ) : (
                <div className="sm-body">
                  <div className="row-grid">
                    {listPhones.map((phone, index) => (
                      <PhoneNumber key={index} title={phone.name} name="number" value={phone.name} qtd={phone.qtd} lastOne={String(phone.lastOne)} register={register} />
                    ))}
                  </div>
                </div>
              )}
              {error ? <div className="mt-20 d-flex flex-row justify-content-center align-center" style={{ color: "red" }}>{error}</div> : ""}
            </div>
            <div className="padding-lbr">
              <Button title="Ligar" type="submit" color="green" width="full" loading={false} />
            </div>
          </form>
        )}
      </Popup>

      {/* Unir informações */}
      <form onSubmit={handleSubmit(onSubmitUnion)}>
        <PopupFixed title="Unir informações" trigger={buttonJoinInfo} setTrigger={setButtonJoinInfo}>
          <PopupBody>
            {userData1 && userData2 && (
              <div>
                <UserCol name="id" title="Id: " userData1Value={userData1.id} userData2Value={userData2.id} register={register} />
                <UserCol name="name" title="Nome: " userData1Value={userData1.name} userData2Value={userData2.name} register={register} />
                <UserCol name="email" title="E-mail: " userData1Value={userData1.email} userData2Value={userData2.email} register={register} />
                <UserCol name="nickname" title="Apelido: " userData1Value={userData1.nickname} userData2Value={userData2.nickname} register={register} />
                <UserCol name="profilepic" title="Foto: " userData1Value={userData1.profile_pic} userData2Value={userData2.profile_pic} register={register} />
                <UserCol name="deleted" title="Deletado: " userData1Value={userData1.deleted} userData2Value={userData2.deleted} register={register} />
                <UserCol name="cpf" title="CPF: " userData1Value={userData1.cpf} userData2Value={userData2.cpf} register={register} />
                <UserCol name="rg" title="RG: " userData1Value={userData1.rg} userData2Value={userData2.rg} register={register} />
                <UserCol name="city" title="Cidade: " userData1Value={userData1.city_name} userData2Value={userData2.city_name} register={register} />
                <UserCol name="state" title="Estado: " userData1Value={userData1.state_name} userData2Value={userData2.state_name} register={register} />
                <UserCol name="phone_number1" title="Telefone: " userData1Value={userData1.phone_number1} userData2Value={userData2.phone_number1} register={register} />
              </div>
            )}
          </PopupBody>
          <PopupFooter right={true}>
            <button className="btn btn-primary" type="submit">Salvar</button>
          </PopupFooter>
        </PopupFixed>
      </form>

      <PopupTags setSelectedTags={setTags} trigger={buttonPopupTags} setTrigger={setButtonPopupTags} />
      <PopupSocialMedia setSelectedMedia={setMedia} trigger={buttonPopupSocialMediaFilter} setTrigger={setButtonPopupSocialMediaFilter} />
      <PopupSelectSocialMedia trigger={mediaTrigger} setTrigger={setMediaTrigger}>
        {socialMediaMutation.isLoading && <LoadingCenter />}
        {!socialMediaMutation.isLoading && (
          <form onSubmit={handleSubmitMedia(handleSetMedia)}>
            <div className="row-grid">
              {socialMediaMutation.data?.data.map((item, index) => (
                <SocialMediaUser key={index} title={item} name="social_media" value={item} register={registerMedia}>
                  {getMediaType(item)}
                </SocialMediaUser>
              ))}
            </div>
            <div className="popup-footer">
              <button className="btn btn-primary" type="submit">
                {takeOnCustomerMutation.isLoading ? <Spinner /> : "Concluir"}
              </button>
              <button className="btn btn-light mr-20" type="button" onClick={() => setMediaTrigger(false)}>Cancelar</button>
            </div>
          </form>
        )}
      </PopupSelectSocialMedia>
      <PopupChatTags title="Gerenciar tags" info={info} trigger={buttonPopupChatTags} setTrigger={setButtonPopupChatTags} editInfoAdmin={editInfoAdmin} chat={currentChat} />

      <Popup title="Editar observação" trigger={buttonPopupObs} setTrigger={setButtonPopupObs} >
        <form onSubmit={handleSubmitObservation(editObservation)}>
          <div className="padding-inner" style={{ paddingTop: "0px" }}>
            <Textarea label="Observação" type="text" placeholder="" name="observation" error={errorsObservation?.error} register={registerObservation} />
          </div>
          <div className="padding-lbr">
            <Button title="Salvar" type="submit" color="green" width="full" loading={obsLoading} />
          </div>
        </form>
      </Popup>

      <Popup title="Redes sociais" trigger={buttonPopupSocialMedia} setTrigger={setButtonPopupSocialMedia}>
        <form onSubmit={handleSubmit(editObservation)}>
          {success && <div style={{ paddingLeft: "20px", paddingRight: "20px" }} className="mb-10 mt-10">{success}</div>}
          {error && <div style={{ paddingLeft: "20px", paddingRight: "20px" }} className="mb-10 mt-10">{error}</div>}

          <div className="padding-inner" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <NewInput mask="+99 99 9 9999 9999" label="WhatsApp" name="whatsapp" type="text" placeholder="" value={whatsappNumber} onChange={e => setWhatsappNumber(e.target.value)} />
          </div>
          <div className="padding-inner" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <NewInput mask="+99 99 9 9999 9999" label="Facebook" name="facebook" type="text" placeholder="" value={facebookNumber} onChange={e => setFacebookNumber(e.target.value)} />
          </div>
          <div className="padding-inner" style={{ paddingTop: "0px" }}>
            <NewInput mask="+99 99 9 9999 9999" label="Instagram" name="instagram" type="text" placeholder="" value={instagramNumber} onChange={e => setInstagramNumber(e.target.value)} />
          </div>

          <div className="padding-lbr">
            <Button title="Salvar" type="submit" color="green" width="full" loading={false} onClick={() => { }} />
          </div>
        </form>
      </Popup>

      <PopupLastAccesses setLastAccess={setLastAccess} trigger={buttonPopupLastAccesses} setTrigger={setButtonPopupLastAccesses} />

      {/* LISTA + TOPO */}
      <div className="customer-container">
        <div className="header flex-separate border-bottom fix-top">
          {expiredMode ? (
            <div className="d-flex flex-row align-center">
              <Link to="/management-customers" className="dropdown__btn rounded__btn mr-10"><ArrowLeft /></Link>
              <span>Arrematantes disponíveis</span>
            </div>
          ) : (
            <div className="d-flex flex-row align">
              <span>Base de clientes</span>
              <div className="customer-nav ml-30">
                <ul>
                  <li><Link to="expired">Arrematantes disponíveis</Link></li>
                  <li><Link to="prospect">Prospect</Link></li>
                </ul>
              </div>
            </div>
          )}

          <div className="d-flex flex-row">
            <div className="inner-search ml-20" style={{ height: "45px" }}>
              <div className="search-icon" onClick={handleSearch} style={{ cursor: "pointer" }}>
                <Search size={24} />
              </div>
              <input
                className="search-input"
                onKeyPress={handleSearch}
                type="text"
                placeholder="Pressione enter p/ pesquisar"
                onChange={e => setSearch(e.target.value)}
                value={search}
              />
            </div>

            <div>
              <button className="dropdown__btn rounded__btn ml-10" onClick={e => { e.preventDefault(); openPopupExport(); }}>
                <Download />
              </button>

              <div className="dropdown">
                <button className="dropdown__btn rounded__btn ml-10"><Filter /></button>
                <ul className="dropdown__nav">
                  <li className="dropdown__item">
                    <a href="/#" className="dropdown__link" onClick={e => { e.preventDefault(); setButtonPopupTags(true); }}>Tags</a>
                  </li>
                  <li className="dropdown__item">
                    <a href="/#" className="dropdown__link" onClick={clearFilters}>Limpar filtros</a>
                  </li>
                  <li className="dropdown__item">
                    <a href="/#" className="dropdown__link" onClick={openModalFilterAdmin}>Filtrar por admin</a>
                  </li>
                  <li className="dropdown__item">
                    <a href="/#" className="dropdown__link" onClick={e => { e.preventDefault(); setButtonPopupLastAccesses(true); }}>Último acesso</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* TABELA */}
        <div className="table-container">
          {customersLoading ? (
            <LoadingCenter />
          ) : (
            <form onSubmit={onSubmit}>
              {expiredMode && actions && (
                <button type="submit" className="btn btn-primary mb-10">
                  Transferir clientes <Share2 />
                </button>
              )}

              <CustomerTable
                checkbox={expiredMode}
                onChangeCheck={onChangeCheck}
                onChangeAll={onChangeAll}
                customers={customers}
                setTriggers={{ setMediaTrigger }}
                setCustomerId={setCustomerId}
                mutations={{ socialMediaMutation }}
                transferCustomer={transferCustomer}
                selectedCustomer={c => setUserId1(c.id)}
                fetchCustomerById={fetchCustomerById}
                setButtonJoinClients={setButtonJoinClients}
              />

              {/* Paginação sempre em /users/master com filtros vigentes */}
              <div className="m-t-20">
                <ProspectPagination
                  page={numberPage}
                  refetch={fetchCustomers}
                  customer={{ data: { meta } }}
                />
              </div>
            </form>
          )}
        </div>
      </div>

      {/* COLUNA DIREITA */}
      <div className="customer">
        <div className="header border-left">
          <span>Informações</span>
          <div>
            {info && info.usadao_id !== '' &&
              <a href={`https://usadaomaquinas.com.br/Gerencial_web32yw/PG_Clientes/DashCliente.php?Codigo=${info.usadao_id}`} target="_blank" rel="noreferrer">
                <button className="action-btn">
                  <img src={require("../imgs/icon-colored.png")} alt="usadão" />
                </button>
              </a>
            }
          </div>
        </div>

        {info ? (
          <div className="chat-user">
            <div className="box no-bg">
              <div className="box-avatar-wrapper">
                <div className="box-avatar" style={{ backgroundImage: `url(${info.profile_pic})` }}></div>
              </div>
              {info?.usadao_id && <span className="chat-user-id">#{info.usadao_id}</span>}
              <span className="chat-user-username">{info.nickname}</span>
              <span className="chat-user-name">{info.name && info.name}</span>
              {info.juridic && (<AlertTriangle style={{ color: "red" }} size={18} />)}
              {info.dataAniversario && <span className="chat-user-username">Idade: {info.year} anos</span>}
              {info.ultimaVizualizacao && <span className="chat-user-username">Ultimo login no leilão:</span>}
              {info.ultimaVizualizacao && <span className="chat-user-id">{moment(info.ultimaVizualizacao).format('LLL')}</span>}
              {info.city_name && info.state_name && <span className="chat-user-username">{info.city_name} / {info.state_name}</span>}
            </div>

            <BoxCustomerMenu user={info} />
            {info?.usadao_id && (
              <Box title="Documentos" defaultOpen={true}>
                <DocDropzone ref={inputFilesRef} user={info} disabled={true} />
              </Box>
            )}

            <Box title="Tags" defaultOpen={true}>
              {info.tags.map((tag, index) => (
                <div key={index} className="tag"><span>#{tag.name}</span></div>
              ))}
            </Box>

            <Box title="Observações" defaultOpen={false}>
              {info?.observations.map((item, index) => (
                <div key={index} className="observation-box text-color">
                  <div><span className="observation-box__author">{item.author}</span></div>
                  <p className="observation-box__body">{item.body}</p>
                </div>
              ))}
            </Box>

            <Box title="Redes sociais" defaultOpen={false}>
              {info.socialMedias.map((m, index) => (
                <img key={index} src={`${m.icon}`} style={{ marginRight: "10px", marginBottom: "15px" }} alt="social" />
              ))}
            </Box>

            {info && <ChartHours user={info.id} />}
          </div>
        ) : (
          infoLoading
            ? <LoadingCenter />
            : <div className="div-center pt-20 pl-20 pr-20 text-center">
                <Any />
                <span className="chat-user-name">Nenhum cliente</span>
                <span className="chat-user-username">Você deve selecionar um cliente para visualizar as informações</span>
              </div>
        )}
      </div>
    </div>
  );
}

export default CustomersDir;
